import { FC } from "react";
import { useDidMount } from "rooks";
import { getAllReportsThunk } from "@/store/reports/thunks/getAllReportsThunk";
import { useAppDispatch } from "@/store/hooks";
import { getWorkflowsThunk } from "@/store/automations/thunks/wokrflows/getWorkflowsThunk";
import { getCostAnomalyAlertsThunk } from "@/store/alerts/thunks/cost-anomaly-alerts/getCostAnomalyAlertsThunk";
import { getUtilizationAlertsThunk } from "@/store/alerts/thunks/utilization-alerts/getUtilizationAlertsThunk";
import {
  IntegrationsDataGrid,
  IntegrationsGridProps,
} from "@/components/pages/integrations/components/common/components/IntegrationsDataGrid";

export const CommunicationIntegrationsDataGrid: FC<IntegrationsGridProps> = (
  props,
) => {
  const dispatch = useAppDispatch();

  // Get data for calculating usages to display in "In Use" column
  useDidMount(() => {
    dispatch(getWorkflowsThunk());
    dispatch(getCostAnomalyAlertsThunk());
    dispatch(getUtilizationAlertsThunk());
    dispatch(getAllReportsThunk());
  });

  return <IntegrationsDataGrid {...props} />;
};
